import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { AddLeadComponent } from "../../components/leads/add-lead/add-lead.component";
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { LeadService } from 'src/app/private/services/lead.service';
import { UsersService } from 'src/app/private/services/users.service';
import { Router } from '@angular/router';
import { BulkUpdateComponent } from "../../components/leads/bulk-update/bulk-update.component";
import { UploadDocumentsComponent } from "../../components/registration/upload-documents/upload-documents.component";
import { LeadEmailComponent } from "../../components/leads/lead-email/lead-email.component";
import { DeleteRegistrationComponent } from "../../components/registration/delete-registration/delete-registration.component";
import { DeleteBulkRegistrationComponent } from "../../components/registration/delete-bulk-registration/delete-bulk-registration.component";
import { LeadCallComponent } from "../../components/leads/lead-call/lead-call.component";
import { RegistrationService } from 'src/app/private/services/registration.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MoveToApplicationComponent } from "../../components/registration/move-to-application/move-to-application.component";
import { BulkMoveToApplicationComponent } from "../../components/registration/bulk-move-to-application/bulk-move-to-application.component";
import { WhatsappCommunicationComponent } from "../../components/leads/whatsapp-communication/whatsapp-communication.component";
import { CreateStudentProfileComponent } from "../../components/registration/create-student-profile/create-student-profile.component";
import { PdfFormGeneratorService } from '../../services/pdf-form-generator.service';


@Component({
  selector: 'app-registration',
  imports: [ToolBarComponent, SharedModule, AddLeadComponent, BulkUpdateComponent, UploadDocumentsComponent, LeadEmailComponent, DeleteRegistrationComponent, DeleteBulkRegistrationComponent, LeadCallComponent, MoveToApplicationComponent, BulkMoveToApplicationComponent, WhatsappCommunicationComponent, CreateStudentProfileComponent, ConfirmDialogModule],
  templateUrl: './registration.component.html',
  styleUrl: './registration.component.scss',
  providers: [MessageService, ConfirmationService]
})
export class RegistrationComponent {

  selectedProducts: any[] = [];
  allCourses: any[] = [];

  totalRecords: number = 0;
  rows: number = 50; // Default page size
  pageSizeOptions = [10, 20, 50]; // Page size options for dropdown
  loading: boolean = false;

  isBulkUpdate: boolean = false;
  isBulkMoveToApplication: boolean = false;
  isMoveToApplication: boolean = false;
  isBulkDeleteLead: boolean = false;
  isBulkSendEmail: boolean = false;
  isOpenAddDialog: boolean = false;
  isCallLead: boolean = false;
  isEmailLead: boolean = false;
  isDeleteLead: boolean = false;
  isUploadDocument: boolean = false;
  isCreateStudentProfile: boolean = false;


  filtersOptions: any[] = [];
  allLeadFeilds: any[] = [];
  importColumns: any[] = [];
  exportItems: any[] = [];
  displayedColumns: any[] = [];
  users: any[] = [];
  leadsData: any[] = [];
  leadDetails: any = {};
  editLeadData: any = {};

  startDate: string = '';
  endDate: string = '';
  isWhatsappLead: boolean = false;

  isAdminUser: boolean = false;


  bulkActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Update Registrations',
          icon: 'pi pi-pencil',
          command: () => {
            this.isBulkUpdate = true;
          }
        },

        {
          label: 'Move to Application',
          icon: 'pi pi-file-export',
          command: () => {
            this.isBulkMoveToApplication = true;
          }
        },
        {
          label: 'Send Email',
          icon: 'pi pi-envelope',
          command: () => {
            const emailMode = this.localStorage.getDefaultEmailCommunicationMode();

            if (emailMode === 'none' || !emailMode) {
              this.confirmationService.confirm({
                message: 'Your communication medium is not connected. Please connect your communication medium to send email.',
                header: 'Communication Medium Not Connected',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Connect Communication',
                rejectLabel: 'Cancel',
                acceptButtonStyleClass: 'p-button-warning',
                accept: () => {
                  this.confirmationService.close();
                  this.router.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 1 } });
                },
                reject: () => {
                  this.confirmationService.close();
                }
              });
              return;
            }

            this.isBulkSendEmail = true;
          }
        },
        {
          label: 'Delete Registration',
          icon: 'pi pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isBulkDeleteLead = true;
          }
        }
      ]
    }
  ];

  setLeadEditData(data: any) {
    this.editLeadData = data;
    this.updateLeadActionItems();
  }

  leadActionItems: any[] = [];

  updateLeadActionItems() {
    const baseItems: any[] = [
      {
        label: 'Edit',
        icon: 'pi pi-fw pi-pencil',
        command: () => {
          this.router.navigate([`/main/registration/${this.editLeadData?.lead_id}`]);
        }
      },
      {
        label: 'Move to Application',
        icon: 'pi pi-fw pi-users',
        command: () => {
          this.isMoveToApplication = true;
        }
      }
    ];

    // Only add "Create Student Profile" if is_student_profile is false
    if (!this.editLeadData?.is_student_profile) {
      baseItems.push({
        label: 'Create Student Profile',
        icon: 'pi pi-fw pi-user-plus',
        command: () => {
          this.isCreateStudentProfile = true;
        }
      });
    } else {
      baseItems.push({
        label: 'Create Student Profile',
        icon: 'pi pi-fw pi-user-plus',
        disabled: true,
      }
      );
    }

    baseItems.push(
      {
        label: 'Download Form',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadRegistrationForm(this.editLeadData);
        }
      },
      {
        label: 'Upload Documents',
        icon: 'pi pi-fw pi-upload',
        command: () => {
          this.isUploadDocument = true;
        }
      },
      {
        label: 'Delete Registration',
        icon: 'pi pi-fw pi-trash',
        command: () => {
          this.isDeleteLead = true
        },
        styleClass: 'delete-menu-item'
      } as any
    );

    this.leadActionItems = [
      {
        label: 'Options',
        items: baseItems
      }
    ];
  }

  ngOnInit() {
    this.setFilterOptions();
    this.getLeadsFields();
    this.setFixedColumn();
    this.getAllUsers();
    this.setExportColumns();
    this.getAllCourses();
  }

  constructor(
    private localStorage: LocalStorageService,
    private api: LeadService,
    private userApi: UsersService,
    private router: Router,
    private registrationApi: RegistrationService,
    private messageService: MessageService,
    private pdfFormGenerator: PdfFormGeneratorService,
    private confirmationService: ConfirmationService
  ) {
    this.isAdminUser = this.localStorage.isAdminUser();
  }

  openRegistrationProfile(rowData: any) {
    this.router.navigate([`/main/registration/${rowData.registration?.lead_id}`]);
  }

  loadCustomers(event: any, searchValue?: string, searchAttribute?: string) {
    this.loading = true;

    const page = (event.first / event.rows) * event.rows;
    const size = event.rows;

    const body: any = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId(),
        "current_stage": "registration",
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"lead\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    if (!this.isAdminUser) {
      body.where['user_id'] = this.localStorage.getUserId();
    }

    if (searchAttribute && (searchValue || searchValue === null)) {
      // Convert is_student_profile string to boolean for API
      const resolvedValue = searchAttribute === 'is_student_profile'
        ? searchValue === 'true'
        : searchValue;
      body.filter = {
        ...body.filter,
        "current_stage": "registration",
        [searchAttribute]: resolvedValue
      }

      if (!this.isAdminUser) {
        body.filter['user_id'] = this.localStorage.getUserId();
      }
    }

    if (this.startDate && this.endDate) {
      body.startDate = this.startDate;
      body.endDate = this.endDate;
    }

    this.api.getAllLeads(body).subscribe({
      next: (data) => {
        this.leadsData = data.rows
        this.totalRecords = data.count;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }


  handleWhatsappLead(event: any) {
    this.isWhatsappLead = true;
    this.leadDetails = event;
  }

  setFilterOptions() {
    this.filtersOptions.push({ header: 'First Name', value: 'first_name', type: 'text' });
    this.filtersOptions.push({ header: 'Last Name', value: 'last_name', type: 'text' });
    this.filtersOptions.push({ header: 'Email', value: 'email', type: 'text' });
    this.filtersOptions.push({ header: 'Phone', value: 'phone', type: 'text' });
    this.filtersOptions.push({
      header: 'Source', value: 'source', type: 'dropdown',
      options: [
        { label: 'Channel Partner', value: 'Channel Partner' },
        { label: 'Conference', value: 'Conference' },
        { label: 'Field Visit', value: 'Field Visit' },
        { label: 'Google', value: 'Google' },
        { label: 'Instagram', value: 'Instagram' },
        { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
        { label: 'Live Session', value: 'Live Session' },
        { label: 'Personal', value: 'Personal' },
        { label: 'Referral', value: 'Referral' },
        { label: 'LinkedIn', value: 'LinkedIn' },
        { label: 'Website', value: 'Website' },
        { label: 'WhatsApp', value: 'WhatsApp' },
        { label: 'Tina', value: 'Tina' },
        { label: 'Intern', value: 'Intern' },
        { label: 'Other', value: 'Other' },
      ]
    });
    this.filtersOptions.push({ header: 'Status', value: 'lead_status', type: 'text' });
      this.filtersOptions.push({
        header: 'Course', value: 'preferred_course', type: 'dropdown',
        options: [] // populated after getAllCourses
      });
    this.filtersOptions.push({
      header: 'Student Profile', value: 'is_student_profile', type: 'dropdown',
      options: [
        { label: 'Yes', value: 'true' },
        { label: 'No', value: 'false' },
      ]
    });
    if (this.isAdminUser) {
      this.filtersOptions.push({
        header: 'Sales Owner', value: 'user_id', type: 'dropdown',
        options: [] // populated after getAllUsers
      });
      this.filtersOptions.push({
        header: 'Assign To', value: 'assigned_to', type: 'dropdown',
        options: [] // populated after getAllUsers
      });
    }
  }

  getLeadsFields() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      module_type: 'registration'
    };
    this.api.getLeadsFields(param).subscribe({
      next: (data) => {
        this.allLeadFeilds = data?.fields.sort((a: any, b: any) => a.sequence - b.sequence);
        data?.fields?.forEach((element: any) => {

          this.importColumns.push(
            {
              field: element?.field_name,
              header: element?.label,
              type: 'dynamic_fields'
            }
          );

          this.exportItems.push(
            {
              label: element?.label,
              value: element?.field_name,
              checked: false,
              type: 'dynamic_fields'
            }
          );

          if (element.visible_in_table == 'true') {
            this.displayedColumns.push(
              {
                field: element?.field_name,
                header: element?.label,
                type: 'dynamic_fields'
              }
            );
          }
        });

        this.displayedColumns.push(
          {
            field: 'action',
            header: 'Actions',
            type: 'actions'
          }
        );

      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllUsers() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
        // Populate Sales Owner and Assign To dropdown options in search filters (admin only)
        this.filtersOptions.forEach((opt) => {
          if (opt.value === 'user_id' || opt.value === 'assigned_to') {
            opt.options = [
              { label: 'Not Assigned', value: null },
              ...this.users.map((user: any) => ({
                label: this.getFullName(user),
                value: user.user_id
              }))
            ];
          }
        });
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }


  getFullName(user: any) {
    return [user?.fname, user?.lname]
      .filter(name => !!name)
      .map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase())
      .join(' ');
  }


  getFullContactName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .map(name => typeof name === 'string' ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() : '')
      .filter(name => name)
      .join(' ') || 'N/A';
  }


  getStatusColor(status: string): string {
    switch (status) {
      case 'Accepted': return '#1FAF38';
      case 'Under Review': return '#F0950C';
      case 'Rejected': return '#D74843';
      case 'Pending': return '#F0950C';
      default: return '#1FAF38'
    }
  }

  getLeadSourceImg(source: string) {
    if (source == 'tina') {
      source = 'Tina'
    } else if (source == 'whatsapp') {
      source = 'WhatsApp'
    } else if (source == 'manual') {
      source = 'Manual'
    }
    return `/assets/images/${source}.png`;
  }


  getAllCourses() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.registrationApi.getAllCourses(param).subscribe({
      next: (data) => {
        this.allCourses = data || [];
        // Populate course dropdown options in search filters
          this.filtersOptions.forEach((opt) => {
            if (opt.value === 'preferred_course') {
              opt.options = [
                { label: 'Not Assigned', value: null },
                ...this.allCourses.map((course: any) => ({
                  label: course.course_name || course.name,
                  value: course.preferred_course || course.course_id
                }))
              ];
            }
          });
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  handleCallLead(event: any) {
    this.isCallLead = true;
    this.leadDetails = event;
  }

  handleEmailLead(event: any) {
    const emailMode = this.localStorage.getDefaultEmailCommunicationMode();

    if (emailMode === 'none' || !emailMode) {
      this.confirmationService.confirm({
        message: 'Your communication medium is not connected. Please connect your communication medium to send email.',
        header: 'Communication Medium Not Connected',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Connect Communication',
        rejectLabel: 'Cancel',
        acceptButtonStyleClass: 'p-button-warning',
        accept: () => {
          this.confirmationService.close();
          this.router.navigate(['/main/settings/configuration-panel'], { queryParams: { activeTab: 1 } });
        },
        reject: () => {
          this.confirmationService.close();
        }
      });
      return;
    }

    this.isEmailLead = true;
    this.leadDetails = event;
  }

  reloadDataTable() {
    this.selectedProducts = [];
    this.loadCustomers({ first: 0, rows: this.rows });
  }

  fnHandleAddd() {
    this.isOpenAddDialog = true;
  }

  handleSearch(event: any) {
    console.log(event);
    this.loadCustomers({ first: 0, rows: this.rows }, event.value, event.selectedFilterAttribute);
  }


  setFixedColumn() {

    this.displayedColumns.push({
      field: 'registration_id',
      header: 'Registration ID',
      type: 'registration_id'
    });

    this.displayedColumns.push({
      field: 'contact_name',
      header: 'Contact Name',
      type: 'contact_name'
    });

    this.displayedColumns.push({
      field: 'createdAt',
      header: 'Added On',
      type: 'createdAt'
    });

    this.displayedColumns.push({
      field: 'Communicate',
      header: 'Communicate',
      type: 'communicate'
    });

    this.displayedColumns.push({
      field: 'user',
      header: 'Sales Owner',
      type: 'nested'
    });

    this.displayedColumns.push({
      field: 'is_student_profile',
      header: 'Student Profile',
      type: 'student_profile'
    });

    this.displayedColumns.push({
      field: 'lead_status',
      header: 'Status',
      type: 'status'
    });


    this.displayedColumns.push({
      field: 'source',
      header: 'Source',
      type: 'source'
    });

    this.displayedColumns.push({
      field: 'Course',
      header: 'Course',
      type: 'course'
    });



    this.displayedColumns.push({
      field: 'Assigned To',
      header: 'Assigned To',
      type: 'assigned_to'
    });

  }

  removeSelectedProducts() {
    this.selectedProducts = [];
  }

  setExportColumns() {
    this.exportItems.push({ label: 'Prefix', value: 'prefix', checked: false });
    this.exportItems.push({ label: 'First Name', value: 'first_name', checked: false });
    this.exportItems.push({ label: 'Last Name', value: 'last_name', checked: false });
    this.exportItems.push({ label: 'Registration ID', value: 'registration_id', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Contact Phone', value: 'phone', checked: false });
    this.exportItems.push({ label: 'Contact Email', value: 'email', checked: false });
    this.exportItems.push({ label: 'Source', value: 'source', checked: false });
    this.exportItems.push({ label: 'City', value: 'city', checked: false });
    this.exportItems.push({ label: 'State', value: 'state', checked: false });
    this.exportItems.push({ label: 'Country', value: 'country', checked: false });
    this.exportItems.push({ label: 'Date of Birth', value: 'date_of_birth', checked: false });
    this.exportItems.push({ label: 'Age', value: 'age', checked: false });
    this.exportItems.push({ label: 'Gender', value: 'gender', checked: false });
    this.exportItems.push({ label: 'Nationality', value: 'nationality', checked: false });
    this.exportItems.push({ label: 'Address', value: 'address', checked: false });
    this.exportItems.push({ label: 'Postal Code', value: 'postal_code', checked: false });
    this.exportItems.push({ label: 'Alternate Phone', value: 'alternate_phone', checked: false });
    this.exportItems.push({ label: 'Interested Course', value: 'interested_course', checked: false });
    this.exportItems.push({ label: 'Preferred Location', value: 'preferred_location', checked: false });
    this.exportItems.push({ label: 'Remarks', value: 'remarks', checked: false });
    this.exportItems.push({ label: 'Status', value: 'status', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Document Status', value: 'document_status', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Guardian Name', value: 'guardian_name', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Guardian Contact', value: 'guardian_contact', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Previous Education', value: 'previous_education', checked: false, type: 'registration' });
    this.exportItems.push({ label: 'Preferred Course', value: 'preferred_course', checked: false, type: 'registration' });

  }

  handleDateFilter(event: any) {
    // console.log('Date Filter:', event);
    if (event.startDate && event.endDate) {
      this.startDate = event.startDate;
      this.endDate = event.endDate;
      this.loadCustomers({ first: 0, rows: this.rows }, undefined, undefined);
    } else {
      this.startDate = '';
      this.endDate = '';
      this.loadCustomers({ first: 0, rows: this.rows });
    }
  }

  handleResetFilters() {
    this.startDate = '';
    this.endDate = '';
    this.loadCustomers({ first: 0, rows: this.rows });
  }



  export(selectedFields: any) {

    let param: any = {
      where: {
        organization_id: this.localStorage.getOrganizationId(),
        current_stage: 'registration',
        campus_id: this.localStorage.getCampusId(),
      },
    };

    if (!this.isAdminUser) {
      param.where['user_id'] = this.localStorage.getUserId();
    }

    this.messageService.add({
      severity: 'info', summary: 'Exporting',
      detail: 'Exporting data, please wait...',
      sticky: true
    });

    this.api.getAllLeadList(param).subscribe({
      next: (data: any) => {

        const mappedData = data.map((lead: any) => {
          let row: any = {};

          selectedFields.forEach((field: any) => {
            if (field.type === 'dynamic_fields') {
              // Handle dynamic fields
              row[field.label] = lead.dynamic_fields?.[field.value] || '';
            } else if (field.type === 'registration') {
              if (field.value === 'preferred_course') {
                row[field.label] = lead.registration?.course?.name || '';
              } else {
                console.log("field", field)
                console.log("lead", lead.registration?.[field.value])
                console.log("lead", lead.registration)
                row[field.label] = lead.registration?.[field.value] || '';
              }
            }
            else {
              row[field.label] = lead[field.value] || '';
            }
          });

          return row;
        });

        // Create worksheet & workbook
        const worksheet = XLSX.utils.json_to_sheet(mappedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads');

        // Save the file
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        const date = new Date();
        const fileName = `Leads_data_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}_${date.getTime()}.xlsx`;

        saveAs(dataBlob, fileName);


        this.messageService.clear();

        this.exportItems.forEach((item) => {
          item.checked = false;
        }
        );

      },
      error: (e) => {

        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error exporting data' });

      },
    });
  }

  downloadRegistrationForm(studentData?: any) {
    if (!studentData) {
      this.messageService.add({
        severity: 'warn',
        summary: 'No Data',
        detail: 'Please select a student to download the form.'
      });
      return;
    }

    this.messageService.add({
      severity: 'info',
      summary: 'Generating',
      detail: 'Generating registration form, please wait...'
    });

    // Define form sections with data mapping
    const sections = this.pdfFormGenerator.createFormSectionsWithData(
      {
        'PERSONAL INFORMATION': [
          { label: 'Prefix', key: 'prefix' },
          { label: 'First Name', key: 'first_name' },
          { label: 'Last Name', key: 'last_name' },
          { label: 'Contact Email', key: 'email' },
          { label: 'Contact Number', key: 'phone' },
          { label: 'Alternate Number', key: 'alternate_phone' },
          { label: 'Date of Birth', key: 'date_of_birth' },
          { label: 'Age', key: 'age' },
          { label: 'Gender', key: 'gender' },
          { label: 'Nationality', key: 'nationality' }
        ],
        'ADDRESS INFORMATION': [
          { label: 'Address', key: 'address' },
          { label: 'City', key: 'city' },
          { label: 'State', key: 'state' },
          { label: 'Country', key: 'country' },
          { label: 'Postal Code', key: 'postal_code' }
        ],
        'ACADEMIC INFORMATION': [
          { label: 'Query Type', key: 'query_type' },
          { label: 'Interested Course', key: 'course_intrested' },
          { label: 'Preferred Location', key: 'preferred_location' },
          { label: 'Previous Education', key: 'previous_education' },
          { label: 'Preferred Course', key: 'preferred_course' }
        ],
        'GUARDIAN INFORMATION': [
          { label: 'Guardian Name', key: 'registration.guardian_name' },
          { label: 'Guardian Contact', key: 'registration.guardian_contact' }
        ],
        'REGISTRATION INFORMATION': [
          { label: 'Registration Number', key: 'registration.registration_id' },
          { label: 'Registration Date', key: 'registration.createdAt' },
          // { label: 'Source', key: 'source' },
          { label: 'Remarks', key: 'remarks' }
        ]
      },
      studentData,
      this.allLeadFeilds
    );

    // Generate PDF using common service
    const studentName = `${studentData.fname || ''}_${studentData.lname || ''}`.trim() || 'Student';
    const date = new Date();
    const fileName = `Registration_Form_${studentName}_${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}.pdf`;

    this.pdfFormGenerator.generatePDFForm({
      formTitle: 'REGISTRATION FORM',
      fileName: fileName,
      sections: sections,
      showSignature: true,
      watermarkText: 'This is an official registration form. Please ensure all information is accurate and complete.',
      data: studentData
    });
  }

}
